(() => {
  function init() {
    const root = document.querySelector('[data-nt-offers]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const links = [...root.querySelectorAll('[data-offers-filter]')];
    const sections = [...document.querySelectorAll('[data-nt-offer-category]')];
    const campaign = root.querySelector('.nt-offers__campaign');
    function show(category) {
      sections.forEach(element => {
        const wrapper = element.closest('.shopify-section') || element;
        wrapper.hidden = category !== 'all' && element.dataset.ntOfferCategory !== category;
      });
      if (campaign) campaign.hidden = category === 'cosmetica';
      links.forEach(link => {
        if (link.dataset.offersFilter === category) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
    function fromHash() {
      show(location.hash === '#nt-offers-benessere' || location.hash.startsWith('#nt-wellness-offer-') ? 'benessere' : location.hash === '#nt-offers-cosmetica' || location.hash.startsWith('#nt-rituale-') ? 'cosmetica' : location.hash.startsWith('#nt-oil-offer-') || ['#nt-ol-primo-acquisto', '#nt-ol-pacchetti'].includes(location.hash) ? 'olio' : 'all');
    }
    links.forEach(link => link.addEventListener('click', () => show(link.dataset.offersFilter)));
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
